//报表管理
const ParkingDayReport = () => import(/*webpackChunkName:'finance'*/"@/page/finance/roadsideRecord/parkingDayReport.vue")
const ParkingMonthReport = () => import(/*webpackChunkName:'finance'*/"@/page/finance/roadsideRecord/parkingMonthReport.vue")
const GroupDayReport = () => import(/*webpackChunkName:'finance'*/"@/page/finance/roadsideRecord/groupDayReport.vue")
const GroupMonthReport = () => import(/*webpackChunkName:'finance'*/"@/page/finance/roadsideRecord/groupMonthReport.vue")
const ChargeRecordByCharger = () => import(/*webpackChunkName:'finance'*/'@/page/finance/roadsideRecord/chargeRecordByCharger.vue')
const ChargeRecordByParkingArea = () => import(/*webpackChunkName:'finance'*/'@/page/finance/roadsideRecord/chargeRecordByParkingArea.vue')
const ChargeFinance = () => import(/*webpackChunkName:'finance'*/'@/page/finance/roadsideRecord/finance.vue')
const InvoiceRecord=()=> import (/*webpackChunkName:'finance' */'@/page/finance/roadsideRecord/invoiceRecord.vue')
const InspectorArrearsStatistics = () => import(/*webpackChunkName:'finance'*/'@/page/finance/roadsideRecord/inspectorArrearsStatistics.vue')
const InspectorChargeStatistics=()=> import (/*webpackChunkName:'finance' */'@/page/finance/roadsideRecord/inspectorChargeStatistics.vue')
const MonthlyCarRenewalRecord = () => import(/*webpackChunkName:'finance' */'@/page/finance/roadsideRecord/monthlyCarRenewalRecord.vue');
const ArrearsDayReport = () => import(/*webpackChunkName:'finance' */'@/page/finance/roadsideRecord/arrearsDayReport.vue');
const ArrearsRateReport = () => import(/*webpackChunkName:'finance' */'@/page/finance/roadsideRecord/arrearsRateReport.vue');
const ChargeUserMonthStatistics = () => import(/*webpackChunkName:'finance' */'@/page/finance/roadsideRecord/charge-user-month-statistics/charge-user-month-statistics.vue');
const RouteTemp = () => import(/*webpackChunkName:'finance'*/'@/page/commons/routeTemp.vue')

export const roadsideRecord={
    path: '/main/report',
    name: '道路报表',
    meta: {
        requireAuth: true,

    },
    component: RouteTemp,
    children: [{
        path: '/main/report/chargeRecordByParkingArea',
        name: '岗位收费统计',
        meta: {
            requireAuth: true,
        },
        component: ChargeRecordByParkingArea
    }, {
        path: '/main/report/chargeRecordByCharger',
        name: '收费员收费统计',
        meta: {
            requireAuth: true,
        },
        component: ChargeRecordByCharger
    }, {
        path: '/main/report/parkingDayReport',
        name: '道路日报',
        meta: {
            requireAuth: true,
        },
        component: ParkingDayReport
    }, {
        path: '/main/report/parkingMonthReport',
        name: '道路月报',
        meta: {
            requireAuth: true,
        },
        component: ParkingMonthReport
    }, {
        path: '/main/report/groupDayReport',
        name: '集团日报',
        meta: {
            requireAuth: true,
        },
        component: GroupDayReport
    }, {
        path: '/main/report/groupMonthReport',
        name: '集团月报',
        meta: {
            requireAuth: true,
        },
        component: GroupMonthReport
    }, {
        path: '/main/report/arrearsDayReport',
        name: '欠费日报',
        meta: {
            requireAuth: true,
        },
        component: ArrearsDayReport
    }
    , {
        path: '/main/report/chargeFinance',
        name: '收费员日报',
        meta: {
            requireAuth: true,
        },
        component: ChargeFinance
    }, {
        path: '/main/invoice/record',
        name: '开票记录',
        meta: {
            requireAuth: true,
        },
        component: InvoiceRecord
    },
    {
        path: '/main/report/inspectorchargestatistics',
        name: '收费员收费概览',
        meta: {
            requireAuth: true,
        },
        component: InspectorChargeStatistics
    },{
        path: '/main/report/inspectorarrearsstatistics',
        name: '收费员追缴欠费统计',
        meta: {
            requireAuth: true,
        },
        component: InspectorArrearsStatistics
    },
    {
        path: '/main/report/monthlyCarRenewalRecord',
        name: '月租车续费记录',
        meta: {
            requireAuth: true,
        },
        component: MonthlyCarRenewalRecord,
    },
    {
        path: '/main/report/arrearsRateReport',
        name: '欠费率报表',
        meta: {
            requireAuth: true,
        },
        component: ArrearsRateReport,
    },
    {
        path: '/main/report/charge-user-month-statistics',
        name: '收费员月度考核',
        meta: {
            requireAuth: true,
        },
        component: ChargeUserMonthStatistics,
    },
    
    
]
}